import React from 'react'

export default class IconsMainNavEarlyAccessFeatures extends React.Component {
    render() {
        let className = 'icons-icon'

        return (
            <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                className={className}
                style={this.props.style}
            >
                <path
                    d='M9.33336 1.33331V5.33331C9.33326 5.55697 9.38943 5.77706 9.49669 5.97331L13.17 12.6933C13.2811 12.8964 13.3375 13.1249 13.3335 13.3563C13.3295 13.5878 13.2653 13.8142 13.1472 14.0133C13.0292 14.2124 12.8613 14.3774 12.6602 14.4919C12.459 14.6065 12.2315 14.6667 12 14.6666H4.00002C3.76854 14.6667 3.54103 14.6065 3.33988 14.4919C3.13873 14.3774 2.97087 14.2124 2.85282 14.0133C2.73476 13.8142 2.67058 13.5878 2.66658 13.3563C2.66258 13.1249 2.71891 12.8964 2.83002 12.6933L6.50336 5.97331C6.61062 5.77706 6.66679 5.55697 6.66669 5.33331V1.33331'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M4.302 10H11.698'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M5.66669 1.33331H10.3334'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
